import { render } from "./WalletStakeModal.vue?vue&type=template&id=2620f2d0"
import script from "./WalletStakeModal.vue?vue&type=script&lang=js"
export * from "./WalletStakeModal.vue?vue&type=script&lang=js"

import "./WalletStakeModal.vue?vue&type=style&index=0&id=2620f2d0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__